const drawler = {
  namespaced: true,
  state: {
    item: "land",
  },
  mutations: {
    setDrawler(state, payload) {
      state.item = payload;
    },
  },
  actions: {},
  getters: {},
};

export default drawler;
